import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../../core/redux/IAppState';

import { addError, addLoading, getLoading } from '../../../core/redux/api/module';
import { API_USAGE_MIGRATION } from '../../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../../core/redux/api/circuitBreaker/module';
import * as R from 'ramda';
import { MigrationRequest } from './migrationRequest';


const KEY_ACTION = ACTION_TYPE.MIGRATE_REDEMPTIONS_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.MIGRATE_REDEMPTIONS_REQUEST,
  ACTION_TYPE.MIGRATE_REDEMPTIONS_RESPONSE,
  ACTION_TYPE.MIGRATE_REDEMPTIONS_ERROR,
];


export type MigrationResponse = {
    code: number,
    errorMessage: string
}

/**
 * An action that can be dispatched to migrate guest redemptions from one entitlement to another
 * @param request - A migrationRequest object with:
 * masterGuestId - The master guest ID for the guest whose redemptions we wish to migrate
 * sourceEntitlementId - The entitlement to migrate FROM
 * targetEntitlementId - the entitlement to migrate TO
 * redemptionIds - a list of redemptiond Ids to migrate
 */
export const migrateRedemptionsAction = (request: MigrationRequest) => makeApiAction(
  {
    method:   'POST',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: API_USAGE_MIGRATION,
    // Entitlement Description intentionally blank
    body: (state: IAppState) => JSON.stringify(request),
    types: ACTIONS.map(action => ({
        type: action,
        meta: { request }
    })) as RsaaTypes,
    bailout:  (state: IAppState) => !!getLoading(state, request.masterGuestId, KEY_ACTION)
                                    || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<MigrationResponse> = (state, action, error, isLoading, payload) => {
  const request = R.path<MigrationRequest>([ 'meta', 'request' ], action);

  // If we're loading, remove the Guest's errors and add a loading state
  if (isLoading) {
    return addLoading(state, request!.masterGuestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  // If we've errored, remove the guest's loading state, and add an error state
  if (error) {
    return addError(withBreaker, request!.masterGuestId, KEY_ACTION, error);
  }

  // Remove Loading/Error and add redemption ID from request to state
  //const noLoadingOrError = removeLoadingAndError(withBreaker, request!.masterGuestId, KEY_ACTION);

  var alteredState = state;

  // We need to update the guest's entitlement numbers, because they've redeemed one. These next ~10 lines are doing that
  //const targetGuest = alteredState.guests.get(request!.masterGuestId);

  return alteredState;
};


export const migrateRedemptionsReducer = makeApiReducer<MigrationResponse>(ACTIONS, KEY_ACTION, reducer);
